import BreadCrump from "../tools/breadcrump";
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import ArrowUpLineIcon from "@rsuite/icons/ArrowUpLine";
import ArrowDownLineIcon from "@rsuite/icons/ArrowDownLine";

export default function ListProperties() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const cookie = getCookies();
    const [list, setList] = useState<any[]>([]);

    const moveOrder = async (item: any, direction: 'up' | 'down') => {
        const idx = list.findIndex((i) => i._id === item._id);
        if (idx < 0) return;
        const otherIdx = direction === 'up' ? idx - 1 : idx + 1;
        if (otherIdx < 0 || otherIdx >= list.length) return;
        const other = list[otherIdx];
        try {
            await axios.put(config.url + '/v1/dashboard/realestate/properties/' + item._id, { arranged: other.arranged }, { headers: { Authorization: 'Bearer ' + cookie['token'] } });
            await axios.put(config.url + '/v1/dashboard/realestate/properties/' + other._id, { arranged: item.arranged }, { headers: { Authorization: 'Bearer ' + cookie['token'] } });
            loaddata();
        } catch (_) {
            Swal.fire(t("Error"), t("Could not update order."), "error");
        }
    };

    const breadcrump = [
        { name: t('Dashboard'), url: '/dashboard' },
        { name: t('Real Estate System'), url: '/dashboard/RealEstate' },
        { name: t('Property Management'), url: null },
    ];

    const loaddata = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/realestate/properties`,
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            const data = res.data.message;
            setList(Array.isArray(data) ? data : []);
        } catch (_) {
            setList([]);
        }
    };

    const onDelete = async (id: string) => {
        const result = await Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this property?"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        });
        if (result.isConfirmed) {
            try {
                await axios({
                    method: 'delete',
                    url: config.url + '/v1/dashboard/realestate/properties/' + id,
                    headers: { Authorization: 'Bearer ' + cookie['token'] }
                });
                loaddata();
                Swal.fire(t("Deleted"), t("Property deleted."), "success");
            } catch (_) {
                Swal.fire(t("Error"), t("Could not delete."), "error");
            }
        }
    };

    useEffect(() => {
        loaddata();
    }, []);

    const getTitle = (item: any) => {
        const lang = (t('lang') as string) || 'en';
        const title = item?.title;
        if (!title || typeof title !== 'object') return item?.code || '-';
        return title[lang] || title.en || title.ku || title.fa || title.ar || title.tr || item?.code || '-';
    };

    const getCityName = (city: any) => {
        if (!city) return '-';
        const lang = (t('lang') as string) || 'en';
        const name = city?.name;
        if (!name || typeof name !== 'object') return city?.code || '-';
        return name[lang] || name.en || name.ku || name.fa || name.ar || name.tr || city?.code || '-';
    };

    const formatPrice = (price: number) => {
        if (!price) return '-';
        return new Intl.NumberFormat('en-US').format(price);
    };

    const formatDeliveryDate = (deliveryDate: any) => {
        if (!deliveryDate || !deliveryDate.month || !deliveryDate.year) return '-';
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return `${monthNames[deliveryDate.month - 1]} ${deliveryDate.year}`;
    };

    return (
        <div className="text-left bg-white p-3 m-4 directions h-[100vh] mb-5 ">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name={t("Property Management")} />

            <div className="flex flex-wrap gap-2 items-center mb-4">
                <button
                    type="button"
                    onClick={() => navigate('/dashboard/RealEstate/properties/new')}
                    className="py-2.5 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
                >
                    {t("Add Property")}
                </button>
            </div>

            <div className="overflow-x-auto border border-gray-200 rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-20">{t("Order")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Title")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Code")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("City")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Status")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Type")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Price")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Delivery")}</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">{t("Actions")}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {list.length === 0 ? (
                            <tr>
                                <td colSpan={9} className="px-4 py-8 text-center text-gray-500">
                                    {t("No properties yet.")}
                                </td>
                            </tr>
                        ) : (
                            list.map((item: any, index: number) => (
                                <tr key={item._id}>
                                    <td className="px-4 py-3">
                                        <div className="flex items-center gap-0.5">
                                            <button
                                                type="button"
                                                onClick={() => moveOrder(item, 'up')}
                                                disabled={index === 0}
                                                title={t("Move up")}
                                                className="p-1 text-gray-600 hover:bg-gray-100 rounded disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center justify-center"
                                            >
                                                <ArrowUpLineIcon style={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => moveOrder(item, 'down')}
                                                disabled={index === list.length - 1}
                                                title={t("Move down")}
                                                className="p-1 text-gray-600 hover:bg-gray-100 rounded disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center justify-center"
                                            >
                                                <ArrowDownLineIcon style={{ fontSize: 18 }} />
                                            </button>
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-sm text-gray-900">{getTitle(item)}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">{item.code || '-'}</td>
                                    <td className="px-4 py-3 text-sm">{getCityName(item.city)}</td>
                                    <td className="px-4 py-3 text-sm">{item.status || '-'}</td>
                                    <td className="px-4 py-3 text-sm">{item.type || '-'}</td>
                                    <td className="px-4 py-3 text-sm">{formatPrice(item.startingPrice)}</td>
                                    <td className="px-4 py-3 text-sm">{formatDeliveryDate(item.deliveryDate)}</td>
                                    <td className="px-4 py-3 text-right">
                                        <div className="flex items-center justify-end gap-1">
                                            <button
                                                type="button"
                                                onClick={() => navigate(`/dashboard/RealEstate/properties/edit/${item._id}`)}
                                                title={t("Edit")}
                                                className="p-1.5 text-blue-600 hover:bg-blue-50 rounded inline-flex items-center justify-center"
                                            >
                                                <EditIcon style={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => onDelete(item._id)}
                                                title={t("Delete")}
                                                className="p-1.5 text-red-600 hover:bg-red-50 rounded inline-flex items-center justify-center"
                                            >
                                                <TrashIcon style={{ fontSize: 18 }} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
